function helperGetDateFullYear (date) {
  return date.getFullYear()
}

module.exports = helperGetDateFullYear



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperGetDateFullYear.js
// module id = 58
// module chunks = 98